import { render, staticRenderFns } from "./MVMHeader.vue?vue&type=template&id=3178fc1e&"
import script from "./MVMHeader.vue?vue&type=script&lang=js&"
export * from "./MVMHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports